import { memo, useCallback } from 'react';

import PropTypes from 'prop-types';

import Filter from 'components/UI/FilterToggleGroup/Filter/Filter';

import styles from './FilterToggleGroup.module.scss';

const FilterToggleGroup = ({ name, value, options, onChange }) => {
  const handleChange = useCallback(
    (value) => onChange(name, value),
    [onChange, name],
  );

  return (
    <div className={styles.wrapper} data-testid="filter-toggle-group-root">
      {options.map(({ label, value: optionValue, Icon }) => (
        <Filter
          key={optionValue}
          label={label}
          value={optionValue}
          isActive={optionValue === value}
          onClick={handleChange}
          Icon={Icon}
        />
      ))}
    </div>
  );
};

FilterToggleGroup.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      Icon: PropTypes.elementType.isRequired,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default memo(FilterToggleGroup);
